import { render, staticRenderFns } from "./SectorSetting.vue?vue&type=template&id=47a488f5"
import script from "./SectorSetting.vue?vue&type=script&lang=js"
export * from "./SectorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports